<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>Liabilities</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-card appearance="outlined" *ngIf="liabilitiesFormArray.controls.length > 0 || (investmentFormArray && investmentFormArray.controls.length > 0)">
      <mat-card-content>
        <ng-container *ngIf="investmentFormArray">
          <div *ngFor="let liability of investmentFormArray.value; index as i">
            <ng-container *ngIf="!liability.isNewInvestment">
              <div class="row">
                <div class="col-sm-2">
                  <div>
                    <mat-form-field appearance="outline">
                      <mat-label>Type</mat-label>
                      <input matInput disabled placeholder="Type" value="Investment">
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-sm-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Monthly repayment</mat-label>
                    <input matInput disabled placeholder="Monthly repayment" value="{{liability.monthlyRepayments}}"
                           matInputCommified>
                    <span matPrefix>$&nbsp;</span>
                    <span matSuffix>.00</span>
                  </mat-form-field>
                </div>
                <div class="col-sm-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Owing/Limit</mat-label>
                    <input matInput placeholder="Owing/Limit" disabled value="{{liability.investmentLoanBalance}}"
                           matInputCommified>
                    <span matPrefix>$&nbsp;</span>
                    <span matSuffix>.00</span>
                  </mat-form-field>
                </div>
                <div class="col-sm-3">
                  <mat-form-field appearance="outline">
                    <mat-label>Lender</mat-label>
                    <input matInput disabled placeholder="Lender" value="{{getLenderName(liability.creditProvider)}}">
                  </mat-form-field>
                  <!-- <select disabled class="full-select" placeholder="Select a lender" [formControl]="investmentFormArray.at(i).get('creditProvider')">
                    <option [value]="null">--- Not in list ---</option>
                    <option *ngFor="let lender of allLenders" [value]="lender.partyRoleId">{{lender.name}}</option>
                  </select> -->
                </div>
                <div class="col-sm-2 d-flex flex-column justify-content-center">
                  <mat-checkbox [disabled]="true" [checked]="!!liability.refinancing">Refinance</mat-checkbox>
                  <mat-checkbox [disabled]="true" [checked]="!!liability.interestOnly">Interest Only</mat-checkbox>
                </div>
                <div class="col-sm-1">
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <div *ngFor="let liability of liabilitiesFormArray.controls; index as i">
          <div class="row" [formGroup]="liability" *ngIf="liabilityTypes">
            <div class="col-sm-2">
              <mat-form-field appearance="outline">
                <mat-label>Select a type</mat-label>
                <ng-container *ngIf="!liability.value.force">
                  <mat-select placeholder="Select a type" formControlName="type"
                              (selectionChange)="handleLiabilityTypeChange(liability, $event.value, i)">
                    <mat-option *ngFor="let type of liabilityTypes" [value]="type.id">{{type.text}}</mat-option>
                  </mat-select>
                </ng-container>
                <ng-container *ngIf="liability.value.force">
                  <input matInput placeholder="Select a type" readonly value="{{liability.value.type | titlecase}}">
                </ng-container>
              </mat-form-field>
            </div>
            <div class="col-sm-2">
              <mat-form-field appearance="outline">
                <mat-label>Monthly repayment</mat-label>
                <input matInput placeholder="Monthly repayment" formControlName="amount" matInputCommified
                       (change)="computeTotalLiabilities()">
                <span matPrefix>$&nbsp;</span>
                <span matSuffix>.00</span>
              </mat-form-field>
              <!-- specific error message for forced rentals-->
              <mat-error class="mb-1"
                         *ngIf="liability.value.type === 'rent' && liability.value.force && liability.get('amount').invalid">
                <small>Residency type of ‘renting’ has been selected, please enter the full rental expense.</small>
              </mat-error>
            </div>
            <div class="col-sm-2">
              <mat-form-field appearance="outline" *ngIf="allowExtValue(liability.value.type, 'requiresOwing')">
                <mat-label>Owing/Limit</mat-label>
                <input matInput placeholder="Owing/Limit" formControlName="limitValue" matInputCommified
                       (keyup)="calcMonthly(liability, $event.target.value)">
                <span matPrefix>$&nbsp;</span>
                <span matSuffix>.00</span>
                <mat-error *ngIf="liability.get('limitValue').hasError('min')">Credit card limit must be at least $1.</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" *ngIf="allowExtValue(liability.value.type, 'allowDescription')">
                <mat-label>Description/Address</mat-label>
                <input matInput placeholder="Description / Address" [readonly]="liability.value.force"
                       formControlName="description">
              </mat-form-field>
            </div>
            <div class="col-sm-3">
              <mat-form-field appearance="outline" *ngIf="allowExtValue(liability.value.type, 'allowCreditProvider')">
                <mat-label>Select a lender</mat-label>
                <mat-select panelClass="full-width" placeholder="Select a lender" formControlName="lender">
                  <mat-option [value]="null">--- Not in list ---</mat-option>
                  <mat-option *ngFor="let lender of allLenders" [value]="lender.partyRoleId">{{lender.name}}</mat-option>
                </mat-select>
                <mat-error *ngIf="liability.get('lender').hasError('required')">Lender is required for credit cards.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-2 d-flex flex-column justify-content-center">
              <mat-checkbox formControlName="refinance" *ngIf="allowExtValue(liability.value.type, 'refi')">Refinance
              </mat-checkbox>
              <mat-checkbox formControlName="interestOnly" *ngIf="allowInterestOnly(liability.value.type)">Interest Only
              </mat-checkbox>
            </div>
            <div class="col-sm-1">
              <button type="button" mat-icon-button (click)="removeLiability(i)" color="warn"
                      *ngIf="!liability.value.force">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          <app-ownership-allocation
            [personList]="personList"
            [companyList]="companyList"
            [trustList]="trustList"
            [formGroup]="liability"
            [isSMSF]="isSMSF">
          </app-ownership-allocation>
        </div>
      </mat-card-content>
    </mat-card>
    <div class="row d-flex mt-4" [formGroup]="formGroup">
      <div class="col-sm-8">
        <button mat-raised-button name="addLiability" class="fmc-button-primary" color="'primary'" type="button" (click)="addLiability(null)">Add
          New
        </button>
      </div>
      <div class="col-sm-4 justify-content-end">
        <mat-form-field appearance="outline">
          <mat-label>Total liabilities</mat-label>
          <input matInput placeholder="Total liabilities" formControlName="totalLiabilitiesValue" matInputCommified readonly>
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-end">
        <app-further-advance-confirmation
          *ngIf="isFurtherAdvance"
          [formGroup]="formGroup"
          [widgetName]="'app-liabilities-details'"
        ></app-further-advance-confirmation>
      </div>
    </div>
  </mat-card-content>
</mat-card>
